import { satisfies } from 'semver';
import { useMemo } from 'react';

function useFilteredChangelog(changelog, range) {
  var splitChangelog = useMemo(function () {
    return divideChangelog(changelog);
  }, [changelog]);
  var filteredChangelog = useMemo(function () {
    return filterChangelog(splitChangelog, range);
  }, [splitChangelog, range]);
  return filteredChangelog;
}
var divideChangelog = function divideChangelog(changelog) {
  var splitToken = "__CHANGELOG_SPLIT_".concat(Date.now(), "__");
  var splitChangelog = [];
  changelog.replace(/[\n\r\s]## /g, "".concat(splitToken, "## ")).split(splitToken).forEach(function (md) {
    // This should only allow us to skip the first chunk which is the name, as
    // well as the unreleased section.
    var match = md.match(/\d+\.\d+\.\d+/);

    if (match) {
      return splitChangelog.push({
        version: match[0],
        content: md
      });
    }
  });
  return splitChangelog;
};
var filterChangelog = function filterChangelog(rawLogs, range) {
  return range ? rawLogs.filter(function (e) {
    return satisfies(e.version, range);
  }) : rawLogs;
};

export { divideChangelog, filterChangelog, useFilteredChangelog };
